import React, { useState, useEffect } from "react";
import { getFormData } from "../../../helpers/formHelper";
import propTypes from "./propTypes";
import LoadingSpinner from "../../LoadingSpinner";
import ThankYouModal from "../ThankYouModal";
import Modal from "../../Modal/Modal";
import ErrorList from "../../Errors/ErrorList";
import UploadMedia from "../../uploads/UploadMedia/UploadMedia";
import { ContributionMap } from "./ContributionMap";
import { pleaseAddCommentText } from "../../../constants/errorMessages";
import { getErrors } from "../../../helpers/errorHelper";

export default function AddContributionModal(props) {
  const [commentText, setCommentText] = useState("");
  const [alias, setAliasText] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const aliasMaxChars = 140; 

  const {
    maxChars,
    errors,
    item,
    handleCloseButtonClick,
    closeRootModal,
    dismissError,
    pendingCommentSubmission,
    pendingCommentSubmissionState,
    setPendingCommentSubmissionState,
    allowMapOnModal,
    createContribution,
    resetSkipAndTop,
    setMergePins,
    setReloadComments,
    setItem,
    allowUsersToSetAlias
  } = props;

  // If there is an error we want to add a border around the offending element
  let errorList = {};
  if (pendingCommentSubmissionState === 'fail' && errors) {
    errorList = getErrors(errors);
  }

  function handleUserInput(input) {
    setCommentText(input.length < maxChars ? input : input.substring(0, maxChars));
  }

  function handleUserInputForAlias(input) {
    setAliasText(input.length < aliasMaxChars ? input : input.substring(0, aliasMaxChars));
  }

  useEffect(() => {
    if(!allowUsersToSetAlias) {
      setAliasText(item.name)
    }
    alias !== "" ? setAliasText(alias) : setAliasText(item.name);
  }, [allowUsersToSetAlias]);

  useEffect(() => {   
    let submitButton = document.getElementById("contributionSubmitButton");
    if(submitButton !== null){
        if(submitting){
        submitButton.disabled = true;
      }
      else{
        submitButton.disabled = false;
      }
    }
   
  }, [submitting]);

  async function submitHandler(e) {
    e.preventDefault();
    //if there are already errors on the form allow resubmission.
    if (pendingCommentSubmissionState === 'fail' && errors) {
      setSubmitting(false);
    }
    dismissError();
    //prevent multiple copies of the same comment from being created.
    if (!submitting) {
      setSubmitting(true);
      // Get all of the named fields into a formData object
      const formData = getFormData(e.target);
     let response = await createContribution(formData);
     if(response !== undefined){       
      setSubmitting(false);
      if(item.externalId === "-1" && response.payload.commentResponse){    
        setItem(response.payload.commentResponse.item);
      }
     }
    }

  }

  function handleThankYouClick() {
    if (props.setMergePins !== undefined) {
      setMergePins(true);
    } else {
      resetSkipAndTop();
      setReloadComments(true);
    }
    setPendingCommentSubmissionState("");
    closeRootModal();
  }

  return (
    <>
      {
        pendingCommentSubmissionState !== "success" &&
        <form className="ugc-contribution-modal ugc-contribution-modal--add-container"
              onSubmit={submitHandler}>
            <h2 className="h3 ugc-contribution-modal--add-container-title">
            Add Comment
          </h2>

          <div className="ugc-contribution-modal__form-content-wrapper">

            {
              pendingCommentSubmissionState === "fail" && errors &&
              <ErrorList errors={props.errors}/>
            }
            {
              item.name &&
                <div className="ugc-contribution-modal--add-location">
                 { !allowUsersToSetAlias || item.externalId !== "-1" ?
                 <>{item.name}</>
             :
             <>
              <textarea
                id="itemAlias"
                name="itemAliasText"
                className={`form-control ugc-contribution-modal--textarea ${errorList.hasAliasError ? 'ugc-contribution-modal--textarea-error border-error' : 'ugc-contribution-modal--textarea-default'}`}
                value={alias}
                aria-describedby="alias-character-count"
                onChange={(e) => handleUserInputForAlias(e.target.value)}/>
              <div id="alias-character-count"
                className="ugc-contribution-modal--alias-character-count">
                {aliasMaxChars - alias.length} characters left
              </div>
             </>
            }
              </div>
            }

            {
              allowMapOnModal &&
                <div className="form-group ugc-contribution-modal--add-map-on-modal">
                    <label className="h4 ugc-contribution-modal--add-map-on-modal-label"
                       htmlFor="locationField">
                      <span className="icon icon--location ugc-contribution-modal--add-map-on-modal-location"/>
                  Location
                </label>
                <input id="locationField"
                      className="form-control ugc-contribution-modal--add-map-on-modal-location-field"
                       disabled="disabled"
                       type="text"
                       value={props.item.location.address}/>
                <ContributionMap
                  easting={props.item.location.easting}
                  northing={props.item.location.northing}/>
              </div>
            }

            <div className="form-group">
                <label className="h4 ugc-contribution-modal--add-comments-field-label"
                     htmlFor="commentsField">
                <span className="icon icon--comment-fill"/>
                {item.implementation.commentMessage}
              </label>

              {
                errorList.hasCommentError &&
                  <div className="ugc-contribution-modal--add-comments-field-error">
                  {pleaseAddCommentText}
                </div>
              }

              <textarea id="commentsField"
                  className={`form-control ugc-contribution-modal--textarea ${errorList.hasCommentError ? 'border-error ugc-contribution-modal--textarea-error' : 'ugc-contribution-modal--textarea-default'}`}
                        name="Text"
                        placeholder="Enter your contribution..."
                        aria-describedby="comments-character-count"
                        value={commentText}
                        onChange={e => handleUserInput(e.target.value)}/>
              <div id="comments-character-count"
                  className="ugc-contribution-modal--alias-character-count">
                {maxChars - commentText.length} characters left
              </div>

              <UploadMedia
                hasMediaError={errorList.hasMediaError}
                hasYouTubeError={errorList.hasYouTubeError}
                allowVideo={item.implementation.allowVideo}
                allowImages={item.implementation.allowImages}/>
            </div>

              <div className="modal__buttons-wrapper ugc-contribution-modal--submit-button">
              <button id="contributionSubmitButton"
                      type="submit"
                  className="govuk-button he-button he-button__primary"
                      data-component="ugcAddContributionModalSubmitButton">
                Submit for approval
              </button>
              <button className="govuk-button he-button he-button__neutral"
                      onClick={e => handleCloseButtonClick(false, closeRootModal, dismissError, e)}
                      data-component="ugcAddContributionModalCancelButton">
                Cancel
              </button>

              {
                pendingCommentSubmission &&
                <LoadingSpinner/>
              }
            </div>
          </div>
        </form>
      }

      {
        pendingCommentSubmissionState === "success" &&
        <Modal closeRootModal={handleThankYouClick}
               isSmallModal={true}>
          <ThankYouModal closeRootModal={handleThankYouClick}/>
        </Modal>
      }
    </>
  );
}

AddContributionModal.propTypes = propTypes;